module.exports = __webpack_public_path__ + "img/file-----3289-1x-png-4@1x.5f383932.png";